export const batchACopy = {
  en: {
    club: "Club profile",
    programme: "Programme",
    fee: "Fees are recorded at the club",
    staff: "Staff",
    import: "Player invites",
    child: "Link a child",
    consent: "Parental consent",
    pay: "Programme payment",
    venue: "Venue",
    slots: "Booking slots",
    prices: "Prices",
    payout: "Payouts wait until a payment provider is connected",
    profile: "Coach profile",
    licence: "FAM or AFC licence",
    assignment: "Club assignment",
    onboardingTitle: "Getting started",
    onboardingBody: "Finish these steps before the club, family, or venue is ready to use.",
    importTitle: "Invite players",
    importBody: "Upload a CSV of parent emails. FanJago stores a one-time link, never a password.",
    importAction: "Create invites",
    importTokens: "Copy these links now. They are not shown again.",
    consentTitle: "Parental consent and privacy",
    consentBody: "Players under 18 stay club-only until a linked parent confirms this version of the consent.",
    recordConsent: "Record consent",
    consentFor: "Consent for",
    consentMyself: "Myself",
    guardianName: "Guardian name",
    guardianEmail: "Guardian email",
    videoConsent: "Video",
    visibility: "Who can see this player",
    clubOnly: "Club only",
    scoutsOnly: "Vetted scouts",
    publicVisibility: "Public",
    photoConsent: "Photo and video consent",
    savePrivacy: "Save privacy",
    dataRights: "Your data",
    requestExport: "Request a copy",
    requestDeletion: "Request deletion",
    exportNow: "Download a copy",
    confirmEmailTitle: "Confirm your email",
    confirmEmailBody: "Open the message we sent, then sign in. You can resend it if it did not arrive.",
    resendEmail: "Resend confirmation",
    phoneTitle: "Phone sign-in",
    phoneBody: "We'll text a one-time code to this number.",
    sendCode: "Send code",
    verifyCode: "Verify code",
    searchTitle: "Search",
    searchBody: "Find clubs, programmes, coaches, venues, and tournaments by name, state, or age. Maps are not used.",
    searchAction: "Search",
    developmentTitle: "Development",
    evaluation: "Coach evaluation",
    saveEvaluation: "Save evaluation",
    highlight: "Highlight link",
    saveHighlight: "Save highlight",
    career: "Confirm a past club",
    confirmClub: "Confirm",
    passport: "Refresh passport",
    lineup: "Published lineup",
    yourSummary: "Your season",
    vettingTitle: "Scout vetting",
    vettingBody: "Search stays closed until an admin clears the background check and you accept the code of conduct.",
    submitVetting: "Submit for review",
    acceptCode: "I accept the code of conduct",
    shortlists: "Shortlists",
    reports: "Scout report",
    marketplaceHeld: "The scouter marketplace is not open",
    marketplaceBody: "Paid scouter matching stays off. Club staff can still record a match privately.",
    volunteers: "Volunteer tasks",
    assignTask: "Assign task",
    invites: "Team manager invite",
    sendInvite: "Send invite",
    matchGraphic: "Match result post",
    publishResult: "Publish result",
    poll: "Poll",
    createPoll: "Create poll",
    pin: "Pin post",
    tagMinors: "Tag players in this post",
    tagAction: "Check photo consent",
    blurred: "This post stays blurred until every tagged minor has photo consent.",
    safeguarding: "Safeguarding",
    raiseConcern: "Raise a concern",
    pdpa: "PDPA",
    recordBreach: "Record a breach",
    dpo: "Data protection officer",
    dpoBody: "Contact the data protection officer at privacy@fanjago.com. Breach notices to the authority are due within 72 hours, and notices to affected people within 7 days when the breach is likely to cause harm.",
    ops: "Operations",
    report: "Report",
    block: "Block",
    profileHidden: "This profile is private.",
    noJobs: "No open roles right now.",
    bulkApprove: "Approve selected",
    queueAge: "Waiting {{days}} days",
    openDocument: "Open document",
    leaderboardEmpty: "The leaderboard is updated on a schedule. Rankings appear after the next refresh.",
    playerName: "Player",
    missingDob: "Players without a date of birth",
    missingDobBody: "These player accounts have no date of birth, so they stay treated as under 18 until an admin records one.",
    saveDob: "Save date of birth",
    noMissingDob: "Every player account has a date of birth.",
    googleNote: "Google sign-in follows the platform setting. It is not a substitute for a confirmed email.",
    saved: "Saved",
    failed: "Could not save",
    smsOff: "SMS sign-in is turned off.",
  },
  ms: {
    club: "Profil kelab",
    programme: "Program",
    fee: "Yuran direkod di kelab",
    staff: "Kakitangan",
    import: "Jemputan pemain",
    child: "Pautkan anak",
    consent: "Persetujuan ibu bapa",
    pay: "Bayaran program",
    venue: "Tempat",
    slots: "Petak masa tempahan",
    prices: "Harga",
    payout: "Bayaran keluar menunggu pembekal pembayaran",
    profile: "Profil jurulatih",
    licence: "Lesen FAM atau AFC",
    assignment: "Tugasan kelab",
    onboardingTitle: "Mula di sini",
    onboardingBody: "Selesaikan langkah ini sebelum kelab, keluarga, atau tempat sedia digunakan.",
    importTitle: "Jemput pemain",
    importBody: "Muat naik CSV e-mel ibu bapa. FanJago menyimpan pautan sekali guna, bukan kata laluan.",
    importAction: "Cipta jemputan",
    importTokens: "Salin pautan ini sekarang. Ia tidak dipaparkan lagi.",
    consentTitle: "Persetujuan ibu bapa dan privasi",
    consentBody: "Pemain bawah 18 tahun kekal dalam kelab sahaja sehingga ibu bapa yang dipautkan mengesahkan versi persetujuan ini.",
    recordConsent: "Rekod persetujuan",
    visibility: "Siapa boleh melihat pemain ini",
    clubOnly: "Kelab sahaja",
    scoutsOnly: "Pengakap yang diluluskan",
    publicVisibility: "Awam",
    photoConsent: "Persetujuan foto dan video",
    savePrivacy: "Simpan privasi",
    consentFor: "Persetujuan untuk",
    consentMyself: "Diri saya",
    guardianName: "Nama penjaga",
    guardianEmail: "E-mel penjaga",
    videoConsent: "Video",
    dataRights: "Data anda",
    requestExport: "Minta salinan",
    requestDeletion: "Minta pemadaman",
    exportNow: "Muat turun salinan",
    confirmEmailTitle: "Sahkan e-mel anda",
    confirmEmailBody: "Buka mesej yang kami hantar, kemudian log masuk. Anda boleh hantar semula jika ia tidak sampai.",
    resendEmail: "Hantar semula pengesahan",
    phoneTitle: "Log masuk telefon",
    phoneBody: "Kami akan menghantar kod sekali guna ke nombor ini.",
    sendCode: "Hantar kod",
    verifyCode: "Sahkan kod",
    searchTitle: "Carian",
    searchBody: "Cari kelab, program, jurulatih, tempat, dan kejohanan mengikut nama, negeri, atau umur. Peta tidak digunakan.",
    searchAction: "Cari",
    developmentTitle: "Pembangunan",
    evaluation: "Penilaian jurulatih",
    saveEvaluation: "Simpan penilaian",
    highlight: "Pautan sorotan",
    saveHighlight: "Simpan sorotan",
    career: "Sahkan kelab dahulu",
    confirmClub: "Sahkan",
    passport: "Kemas kini pasport",
    lineup: "Barisan yang diterbitkan",
    yourSummary: "Musim anda",
    vettingTitle: "Saringan pengakap",
    vettingBody: "Carian ditutup sehingga pentadbir meluluskan semakan latar belakang dan anda menerima kod tatakelakuan.",
    submitVetting: "Hantar untuk semakan",
    acceptCode: "Saya menerima kod tatakelakuan",
    shortlists: "Senarai pendek",
    reports: "Laporan pengakap",
    marketplaceHeld: "Pasaran pengakap belum dibuka",
    marketplaceBody: "Padanan pengakap berbayar kekal ditutup. Kakitangan kelab masih boleh merekod padanan secara peribadi.",
    volunteers: "Tugas sukarelawan",
    assignTask: "Tugaskan",
    invites: "Jemputan pengurus pasukan",
    sendInvite: "Hantar jemputan",
    matchGraphic: "Siaran keputusan perlawanan",
    publishResult: "Terbitkan keputusan",
    poll: "Undian",
    createPoll: "Cipta undian",
    pin: "Semat siaran",
    tagMinors: "Tandakan pemain dalam siaran ini",
    tagAction: "Semak persetujuan foto",
    blurred: "Siaran ini kekal kabur sehingga setiap kanak-kanak yang ditanda mempunyai persetujuan foto.",
    safeguarding: "Perlindungan",
    raiseConcern: "Bangkitkan kebimbangan",
    pdpa: "PDPA",
    recordBreach: "Rekod pelanggaran",
    dpo: "Pegawai perlindungan data",
    dpoBody: "Hubungi pegawai perlindungan data di privacy@fanjago.com. Notis kepada pihak berkuasa perlu dalam 72 jam, dan notis kepada orang terjejas dalam 7 hari jika pelanggaran mungkin menyebabkan mudarat.",
    ops: "Operasi",
    report: "Laporkan",
    block: "Sekat",
    profileHidden: "Profil ini peribadi.",
    noJobs: "Tiada jawatan terbuka buat masa ini.",
    bulkApprove: "Luluskan pilihan",
    queueAge: "Menunggu {{days}} hari",
    openDocument: "Buka dokumen",
    leaderboardEmpty: "Carta kedudukan dikemas kini mengikut jadual. Kedudukan muncul selepas kemas kini seterusnya.",
    playerName: "Pemain",
    missingDob: "Pemain tanpa tarikh lahir",
    missingDobBody: "Akaun pemain ini tiada tarikh lahir, jadi mereka kekal dianggap bawah 18 tahun sehingga pentadbir merekodkannya.",
    saveDob: "Simpan tarikh lahir",
    noMissingDob: "Setiap akaun pemain ada tarikh lahir.",
    googleNote: "Log masuk Google mengikut tetapan platform. Ia bukan pengganti e-mel yang disahkan.",
    saved: "Disimpan",
    failed: "Tidak dapat disimpan",
    smsOff: "Log masuk SMS dimatikan.",
  },
};
